// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "backend/client_service.proto" (package "tusk.drift.backend.v1", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ClientService } from "./client_service";
import type { GetObservableServiceInfoResponse } from "./client_service";
import type { GetObservableServiceInfoRequest } from "./client_service";
import type { CreateApiKeyResponse } from "./client_service";
import type { CreateApiKeyRequest } from "./client_service";
import type { VerifyRepoAccessResponse } from "./client_service";
import type { VerifyRepoAccessRequest } from "./client_service";
import type { CreateObservableServiceResponse } from "./client_service";
import type { CreateObservableServiceRequest } from "./client_service";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAuthInfoResponse } from "./client_service";
import type { GetAuthInfoRequest } from "./client_service";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service tusk.drift.backend.v1.ClientService
 */
export interface IClientServiceClient {
    /**
     * @generated from protobuf rpc: GetAuthInfo
     */
    getAuthInfo(input: GetAuthInfoRequest, options?: RpcOptions): UnaryCall<GetAuthInfoRequest, GetAuthInfoResponse>;
    /**
     * @generated from protobuf rpc: CreateObservableService
     */
    createObservableService(input: CreateObservableServiceRequest, options?: RpcOptions): UnaryCall<CreateObservableServiceRequest, CreateObservableServiceResponse>;
    /**
     * @generated from protobuf rpc: VerifyRepoAccess
     */
    verifyRepoAccess(input: VerifyRepoAccessRequest, options?: RpcOptions): UnaryCall<VerifyRepoAccessRequest, VerifyRepoAccessResponse>;
    /**
     * @generated from protobuf rpc: CreateApiKey
     */
    createApiKey(input: CreateApiKeyRequest, options?: RpcOptions): UnaryCall<CreateApiKeyRequest, CreateApiKeyResponse>;
    /**
     * Get observable service info including default branch
     *
     * @generated from protobuf rpc: GetObservableServiceInfo
     */
    getObservableServiceInfo(input: GetObservableServiceInfoRequest, options?: RpcOptions): UnaryCall<GetObservableServiceInfoRequest, GetObservableServiceInfoResponse>;
}
/**
 * @generated from protobuf service tusk.drift.backend.v1.ClientService
 */
export class ClientServiceClient implements IClientServiceClient, ServiceInfo {
    typeName = ClientService.typeName;
    methods = ClientService.methods;
    options = ClientService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAuthInfo
     */
    getAuthInfo(input: GetAuthInfoRequest, options?: RpcOptions): UnaryCall<GetAuthInfoRequest, GetAuthInfoResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAuthInfoRequest, GetAuthInfoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateObservableService
     */
    createObservableService(input: CreateObservableServiceRequest, options?: RpcOptions): UnaryCall<CreateObservableServiceRequest, CreateObservableServiceResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateObservableServiceRequest, CreateObservableServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VerifyRepoAccess
     */
    verifyRepoAccess(input: VerifyRepoAccessRequest, options?: RpcOptions): UnaryCall<VerifyRepoAccessRequest, VerifyRepoAccessResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<VerifyRepoAccessRequest, VerifyRepoAccessResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateApiKey
     */
    createApiKey(input: CreateApiKeyRequest, options?: RpcOptions): UnaryCall<CreateApiKeyRequest, CreateApiKeyResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateApiKeyRequest, CreateApiKeyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get observable service info including default branch
     *
     * @generated from protobuf rpc: GetObservableServiceInfo
     */
    getObservableServiceInfo(input: GetObservableServiceInfoRequest, options?: RpcOptions): UnaryCall<GetObservableServiceInfoRequest, GetObservableServiceInfoResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetObservableServiceInfoRequest, GetObservableServiceInfoResponse>("unary", this._transport, method, opt, input);
    }
}
